<template>
  <b-modal
    id="modalCreateCalculationProductionAddWorkers"
    v-model="localActive"
    title="Показывать в таблице должности"
    centered
    hide-footer
    hide-header
    @close="localActive = false"
  >
    <div class="m-add-workers">
      <svg
        class="m-add-workers-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-add-workers-title">{{ modalTitle }}</div>
      <div class="m-add-workers-search">
        <c-switcher
          v-if="!isDeliveryTab"
          v-model="isShowWorkersAllFilials"
          class="m-add-workers-search-switcher"
          label="Все филиалы"
        />
        <c-input
          v-model="search"
          class="m-add-workers-search-input"
          :class="{ 'w-100': isDeliveryTab }"
          placeholder="Поиск по ФИО"
          icon="search"
          placeholder-style="italic"
          clearable
        />
      </div>

      <div class="position-relative">
        <div id="m-add-workers-content-shadow-top" class="m-add-workers-content-shadow-top"></div>
        <div id="m-add-workers-content" class="m-add-workers-content" @scroll="setShadowsOnScroll">
          <div class="m-add-workers-content-result">
            <template v-for="worker in workersLocal">
              <c-switcher
                v-if="displayWorkerSwitcher(worker)"
                :key="worker.key"
                v-model="worker.isActive"
                class="m-add-workers-content-result-item"
                type="checkbox"
                :label="worker.name"
              />
            </template>
          </div>
          <div
            v-if="
              !workersLocal.some(
                (worker) =>
                  (worker.isVisible && isDeliveryTab) ||
                  (worker.isVisible && ((!isShowWorkersAllFilials && worker.is_filial) || isShowWorkersAllFilials)),
              )
            "
            class="m-add-workers-content-empty"
          >
            Сотрудники не найдены
          </div>
        </div>
        <div id="m-add-workers-content-shadow-bottom" class="m-add-workers-content-shadow-bottom"></div>
      </div>

      <div class="m-add-workers-actions">
        <c-button size="large" class="m-add-workers-actions-reset" label="Сбросить" @click="reset()" />
        <c-button
          class="m-add-workers-actions-apply"
          label="Применить"
          color="blue"
          size="large"
          @click="submitWorkers()"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from "moment";
import { isProductionRankWithoutFixedSalary } from "@/entities/models/calculations";
import Input from "@/components/controls/input";
import Button from "@/components/controls/button";
import Switcher from "@/components/controls/switcher";

export default {
  name: "m-production-add-post",

  components: {
    "c-input": Input,
    "c-button": Button,
    "c-switcher": Switcher,
  },

  props: [
    "active",
    "workers",
    "tableRecords",
    "groupCode",
    "data",
    "modalTitle",
    "isDeliveryTab",
    "tab",
    "isCalcFirstLoad",
    "selected"
  ],

  data() {
    return {
      localActive: false,
      workersLocal: [],
      workersStatesLocal: [],
      search: "",
      sumHoursWorked: 0,
      isShowWorkersAllFilials: false,
    };
  },

  watch: {
    isShowWorkersAllFilials() {
      setTimeout(() => {
        this.setShadowsOnScroll();
      }, 100);
    },
    localActive(value) {
      if (!value) {
        this.$emit("close");
        setTimeout(() => {
          this.isShowWorkersAllFilials = false;
          this.search = "";
        });
      }
    },
    active(value) {
      this.localActive = value;
    },
    workers(value) {
      //console.log(value );
      if (this.tab === "byPeriod") {
        if (this.isDeliveryTab) {
          this.workersLocal = value.map((worker) => {
            const defaultPersonalHistory = [
              {
                type: worker.personal > 0 ? "+" : "-",
                amount: Math.abs(Math.round(worker.personal)),
                authorName: "vpadmin",
                comment: null,
                reason: null,
                reason_id: null,
              },
            ];
            const b = this.tableRecords.findIndex((workerActive) => workerActive.id === worker.worker_id);
            const findReferenceDataWorker = this.data.allDrivers[worker.worker_id];

            if (findReferenceDataWorker !== undefined) {
              return {
                is_filial: worker.is_filial ? worker.is_filial : false,
                id: worker.worker_id,
                codeGroup: "driver",
                name: worker.showname,
                personalAmount: worker.personalAmount,
                employee: {
                  value: worker.showname,
                },
                doc_problem: findReferenceDataWorker.doc_problem,
                recommened_category: 0,
                premium_personal_account: {
                  value: `${Math.round(
                    findReferenceDataWorker.personal_amount,
                  )}`,
                },
                personal_account_transactions: {
                  value: Math.round(worker.personal),
                  items:
                    worker.personal_history && worker.personal_history.length > 0
                      ? worker.personal_history
                      : defaultPersonalHistory,
                },
                account_accrued: Math.round(worker.sum),
                account_removed: Math.round(worker.sum_prepay),
                account_balance: Math.round(worker.personal),
                personal_account_accrued: {
                  value: Math.round(worker.sum),
                },
                personal_account_removed: {
                  value: worker.sum_prepay,
                },
                personal_account_balance: {
                  value: worker.personal,
                },
                count_smenas: {
                  value: worker.count_smenas,
                },
                sum_deposit: {
                  value: worker.sum_deposit,
                },
                balance: {
                  value: worker.balance,
                },

                period_working_time: {
                  value: this.convertHoursToHHMM(worker.worktime),
                },
                order_value: {
                  value: worker.sum_orders,
                },
                average_check: {
                  value: worker.orders_sum !== 0 ? Math.round(worker.orders_sum / worker.orders) : 0,
                },
                travel_time_calculation: {
                  value: this.convertHoursToHHMM(worker.plan_duration),
                  valueInDecimal: worker.plan_duration,
                },
                actual_travel_time: {
                  value: this.convertHoursToHHMM(worker.duration),
                  valueInDecimal: worker.duration,
                },
                kpi: {
                  value: worker.duration > 0 ? Math.round((worker.plan_duration / worker.duration) * 10 * 10) / 10 : 0,
                },
                idle_time: {
                  value:
                    worker.worktime > 0 ? Math.round(((worker.worktime - worker.duration) / worker.worktime) * 100) : 0,
                },
                time: {
                  value: worker.sum_duration,
                },
                orders: {
                  value: worker.orders,
                },
                distance: {
                  value: Math.round(worker.distance),
                },
                money_per_distance: {
                  value: Math.round(worker.sum_distance),
                },
                sum_orders: {
                  value: Math.round(worker.sum_orders),
                },

                minimum_wage: {
                  value: worker.sum_min,
                },
                allowance: {
                  value: worker.sum_surcharge !== 0 ? Number(worker.sum_surcharge).toFixed(2) : 0,
                },
                late_checkout_surcharge: {
                  value: worker.sum_departure,
                },
                short_shift_allowance: {
                  value: worker.sum_short_shift,
                },
                prize: {
                  value: worker.sum_bonus,
                  items: worker.bonuses,
                },
                fine: {
                  value: worker.sum_penalty,
                  items: worker.fines,
                },
                total_accrued: {
                  value: Math.round(worker.sum),
                },
                already_paid: {
                  value: Math.round(worker.sum_prepay) * -1,
                },
                to_payoff: {
                  value: Math.round(worker.sum_paid),
                },
                isVisible: true,
                isActive: b !== -1,
                isShowRow: true,
              };
            }
            return {
              is_filial: worker.is_filial ? worker.is_filial : false,
              id: worker.worker_id,
              codeGroup: "driver",
              name: worker.showname,
              employee: {
                value: worker.showname,
              },
              doc_problem: 0,
              recommened_category: 0,
              premium_personal_account: {
                value: `${0}`,
              },
              personal_account_transactions: {
                value: Math.round(worker.personal),
                items:
                  worker.personal_history && worker.personal_history.length > 0
                    ? worker.personal_history
                    : defaultPersonalHistory,
              },
                account_accrued: Math.round(worker.sum),
                account_removed: Math.round(worker.sum_prepay),
                account_balance: Math.round(worker.personal),
              
              personal_account_accrued: {
                value: Math.round(worker.sum),
              },
              personal_account_removed: {
                value: worker.sum_prepay,
              },
              personal_account_balance: {
                value: worker.personal,
              },
              count_smenas: {
                value: worker.count_smenas,
              },
                sum_deposit: {
                  value: worker.sum_deposit,
                },
                balance: {
                  value: worker.balance,
                },


              period_working_time: {
                value: this.convertHoursToHHMM(worker.worktime),
              },
              order_value: {
                value: worker.sum_orders,
              },
              average_check: {
                value: worker.orders_sum !== 0 ? Math.round(worker.orders_sum / worker.orders) : 0,
              },
              travel_time_calculation: {
                value: this.convertHoursToHHMM(worker.plan_duration),
                valueInDecimal: worker.plan_duration,
              },
              actual_travel_time: {
                value: this.convertHoursToHHMM(worker.duration),
                valueInDecimal: worker.duration,
              },
              kpi: {
                value: worker.duration > 0 ? Math.round((worker.plan_duration / worker.duration) * 10 * 10) / 10 : 0,
              },
              idle_time: {
                value:
                  worker.worktime > 0 ? Math.round(((worker.worktime - worker.duration) / worker.worktime) * 100) : 0,
              },
              time: {
                value: worker.sum_duration,
              },
              orders: {
                value: worker.sum_orders,
              },
              distance: {
                value: Math.round(worker.distance),
              },
              money_per_distance: {
                value: Math.round(worker.sum_distance),
              },
              sum_orders: {
                value: Math.round(worker.sum_orders),
              },
              minimum_wage: {
                value: worker.sum_min,
              },
              allowance: {
                value: worker.sum_surcharge !== 0 ? Number(worker.sum_surcharge).toFixed(2) : 0,
              },
              late_checkout_surcharge: {
                value: worker.sum_departure,
              },
              short_shift_allowance: {
                value: worker.sum_short_shift,
              },
              prize: {
                value: worker.sum_bonus,
                items: worker.bonuses,
              },
              fine: {
                value: worker.sum_penalty,
                items: worker.fines,
              },
              total_accrued: {
                value: Math.round(worker.sum),
              },
              already_paid: {
                value: Math.round(worker.sum_prepay) * -1,
              },
              to_payoff: {
                value: Math.round(worker.sum_paid),
              },
              isVisible: true,
              isActive: b !== -1,
              isShowRow: true,
            };
          });
        } else {
          this.workersLocal = value.map((worker) => {
            const defaultPersonalHistory = [
              {
                type: worker.personal > 0 ? "+" : "-",
                amount: Math.abs(Math.round(worker.personal)),
                authorName: "vpadmin",
                comment: null,
                reason: null,
                reason_id: null,
              },
            ];
            const findGroupIndex = this.tableRecords.findIndex((group) => group.code === worker.post_code);
            if (findGroupIndex !== -1) {
              const b = this.tableRecords[findGroupIndex].records.findIndex(
                (workerActive) => workerActive.id === worker.worker_id,
              );
              const findReferenceDataWorker = this.data.production[`${worker.worker_id}-${worker.post_code}`];
              if (findReferenceDataWorker !== undefined) {
                return {
                  is_filial: worker.is_filial !== undefined ? worker.is_filial : false,
                  codeGroup: worker.post_code,
                  post_code: worker.post_code,
                  category_id: worker.category_id,
                  category_number: worker.category_number,
                  worktime: worker.worktime,
                  sum_compens: worker.sum_compens,
                  sum_deposit: worker.sum_deposit,
                  sum_surcharge: worker.sum_surcharge,
                  id: worker.worker_id,
                  worker_id: worker.worker_id,
                  name: worker.showname,
                  doc_problem: findReferenceDataWorker.doc_problem,
                  recommened_category: findReferenceDataWorker.recommened_category,
                  personalAmount: findReferenceDataWorker.personal_amount,
                  premium_personal_account: {
                    value: `${findReferenceDataWorker.bonus_amount}/${Math.round(
                      findReferenceDataWorker.personal_amount,
                    )}`,
                  },
                  personal_account_transactions: {
                    value: Math.round(worker.personal),
                    items:
                      worker.personal_history && worker.personal_history.length > 0
                        ? worker.personal_history
                        : defaultPersonalHistory,
                  },
                  personal_account_accrued: {
                    value: Math.round(worker.sum),
                  },
                  personal_account_removed: {
                    value: Math.round(worker.sum_prepay),
                  },
                  personal_account_balance: {
                    value: Math.round(worker.personal),
                  },
                  count_smenas: {
                    value: worker.count_smenas,
                  },
                  period_working_time: {
                    value: this.convertHoursToHHMM(worker.worktime),
                  },
                  period_rank: {
                    value: worker.category_number,
                  },
                  period_compensation: {
                    value: worker.sum_compens,
                  },
                  load: {
                    value: worker.count_products,
                  },
                  salary: {
                    value: worker.s_salary,
                  },
                  main_part_salary: {
                    value: isProductionRankWithoutFixedSalary(worker.category_number)
                      ? 0
                      : Math.round((worker.s_salary / 12) * this.sumHoursWorked),
                  },
                  revenue_standard_hour: {
                    value: Math.round(this.getRevenueStandardHour(worker.post_code)),
                  },
                  ratio_standart: {
                    value: worker.s_koutput,
                  },
                  revenue_standard: {
                    value: Math.round(worker.normday),
                  },
                  bonus_rate: {
                    value: worker.s_kbonus,
                  },
                  deprivation_coefficient: {
                    value: worker.s_kpenaly,
                  },
                  corrected_time: {
                    value: this.convertHoursToHHMM(worker.worktime_correctly),
                  },
                  premium_for_exceeding_standard: {
                    value: Math.round(worker.sum_bonus_calc),
                  },
                  depreciation: {
                    value: Math.round(worker.sum_penalty_calc),
                  },
                  prize: {
                    value: worker.sum_bonus,
                    items: worker.bonuses,
                  },
                  fine: {
                    value: worker.sum_penalty,
                    items: worker.fines,
                  },
                  total_accrued: {
                    value: Math.round(worker.sum),
                  },
                  already_paid: {
                    value: Math.round(worker.sum_prepay) * -1,
                  },
                  to_payoff: {
                    value: Math.round(worker.sum_paid),
                  },
                  isActive: b !== -1,
                  isVisible: true,
                  isShowRow: true,
                };
              }
              return {
                is_filial: worker.is_filial !== undefined ? worker.is_filial : false,
                codeGroup: worker.post_code,
                post_code: worker.post_code,
                category_id: worker.category_id,
                category_number: worker.category_number,
                worktime: worker.worktime,
                sum_compens: worker.sum_compens,
                sum_deposit: worker.sum_deposit,
                sum_surcharge: worker.sum_surcharge,
                id: worker.worker_id,
                worker_id: worker.worker_id,
                name: worker.showname,
                doc_problem: 0,
                recommened_category: 0,
                premium_personal_account: {
                  value: `${0}/${0}`,
                },
                personal_account_transactions: {
                  value: Math.round(worker.personal),
                  items:
                    worker.personal_history && worker.personal_history.length > 0
                      ? worker.personal_history
                      : defaultPersonalHistory,
                },
                personal_account_accrued: {
                  value: Math.round(worker.sum),
                },
                personal_account_removed: {
                  value: Math.round(worker.sum_prepay),
                },
                personal_account_balance: {
                  value: Math.round(worker.personal),
                },
                count_smenas: {
                  value: worker.count_smenas,
                },
                period_working_time: {
                  value: this.convertHoursToHHMM(worker.worktime),
                },
                period_rank: {
                  value: worker.category_number,
                },
                period_compensation: {
                  value: worker.sum_compens,
                },
                load: {
                  value: worker.count_products,
                },
                salary: {
                  value: worker.s_salary,
                },
                main_part_salary: {
                  value: isProductionRankWithoutFixedSalary(worker.category_number)
                    ? 0
                    : Math.round((worker.s_salary / 12) * this.sumHoursWorked),
                },
                revenue_standard_hour: {
                  value: Math.round(this.getRevenueStandardHour(worker.post_code)),
                },
                ratio_standart: {
                  value: worker.s_koutput,
                },
                revenue_standard: {
                  value: Math.round(worker.normday),
                },
                bonus_rate: {
                  value: worker.s_kbonus,
                },
                deprivation_coefficient: {
                  value: worker.s_kpenaly,
                },
                corrected_time: {
                  value: this.convertHoursToHHMM(worker.worktime_correctly),
                },
                premium_for_exceeding_standard: {
                  value: Math.round(worker.sum_bonus_calc),
                },
                depreciation: {
                  value: Math.round(worker.sum_penalty_calc),
                },
                prize: {
                  value: worker.sum_bonus,
                  items: worker.bonuses,
                },
                fine: {
                  value: worker.sum_penalty,
                  items: worker.fines,
                },
                total_accrued: {
                  value: Math.round(worker.sum),
                },
                already_paid: {
                  value: Math.round(worker.sum_prepay) * -1,
                },
                to_payoff: {
                  value: Math.round(worker.sum_paid),
                },
                isActive: b !== -1,
                isVisible: true,
                isShowRow: true,
              };
            }
            return {};
          });
        }
   /*   } else if (this.isDeliveryTab) {
        this.workersLocal = value.map((worker) => {
          const b = this.tableRecords.findIndex((workerActive) => workerActive.id === worker.worker_id);
          const findReferenceDataWorker = this.data.drivers[worker.worker_id];
          if (findReferenceDataWorker !== undefined) {
            return {
              id: worker.worker_id,
              codeGroup: "driver",
              name: worker.showname,
              employee: {
                value: worker.showname,
              },
              doc_problem: findReferenceDataWorker.doc_problem,
              recommened_category: 0,
              premium_personal_account: {
                value: `${findReferenceDataWorker.bonus_amount}/${findReferenceDataWorker.personal_amount}`,
              },
              personal_account_transactions: {
                value: worker.personal,
              },
              working_interval: {
                value: worker.intervals,
              },
              amount_working_time: {
                value: this.getAmountWorkerTime(worker.intervals),
              },
              number_of_orders: {
                value: worker.orders,
              },
              order_value: {
                value: worker.sum_orders,
              },
              average_check: {
                value: worker.orders_sum !== 0 ? Math.round(worker.orders_sum / worker.orders) : 0,
              },
              travel_time_calculation: {
                value: this.convertHoursToHHMM(worker.plan_duration),
                valueInDecimal: worker.plan_duration,
              },
              actual_travel_time: {
                value: this.convertHoursToHHMM(worker.duration),
                valueInDecimal: worker.duration,
              },
              kpi: {
                value: worker.duration > 0 ? Math.round((worker.plan_duration / worker.duration) * 10 * 10) / 10 : 0,
              },
              idle_time: {
                value:
                  worker.worktime > 0 ? Math.round(((worker.worktime - worker.duration) / worker.worktime) * 100) : 0,
              },
              time: {
                value: worker.sum_duration,
              },
              orders: {
                value: worker.sum_orders,
              },
              distance: {
                value: Math.round(worker.distance),
              },
              money_per_distance: {
                value: Math.round(worker.sum_distance),
              },
              minimum_wage: {
                value: worker.sum_min,
              },
              allowance: {
                value: worker.sum_surcharge,
              },
              late_checkout_surcharge: {
                value: worker.sum_departure,
              },
              short_shift_allowance: {
                value: worker.sum_short_shift,
              },
              prize: {
                value: worker.sum_bonus,
                items: worker.bonuses,
              },
              fine: {
                value: worker.sum_penalty,
                items: worker.fines,
              },
              total_accrued: {
                value: Math.round(worker.sum),
              },
              to_payoff: {
                value: Math.round(worker.sum_round),
              },
              isShowRow: true,
              isActive: b !== -1,
              isVisible: true,
            };
          }
          return {
            id: worker.worker_id,
            codeGroup: "driver",
            name: worker.showname,
            employee: {
              value: worker.showname,
            },
            doc_problem: "",
            recommened_category: 0,
            premium_personal_account: {
              value: "0/0",
            },
            personal_account_transactions: {
              value: worker.personal,
            },
            working_interval: {
              value: worker.intervals,
            },
            amount_working_time: {
              value: this.getAmountWorkerTime(worker.intervals),
            },
            number_of_orders: {
              value: worker.orders,
            },
            order_value: {
              value: worker.sum_orders,
            },
            average_check: {
              value: worker.orders_sum !== 0 ? Math.round(worker.orders_sum / worker.orders) : 0,
            },
            travel_time_calculation: {
              value: this.convertHoursToHHMM(worker.plan_duration),
              valueInDecimal: worker.plan_duration,
            },
            actual_travel_time: {
              value: this.convertHoursToHHMM(worker.duration),
              valueInDecimal: worker.duration,
            },
            kpi: {
              value: worker.duration > 0 ? Math.round((worker.plan_duration / worker.duration) * 10 * 10) / 10 : 0,
            },
            idle_time: {
              value:
                worker.worktime > 0 ? Math.round(((worker.worktime - worker.duration) / worker.worktime) * 100) : 0,
            },
            time: {
              value: worker.sum_duration,
            },
            orders: {
              value: worker.sum_orders,
            },
            distance: {
              value: Math.round(worker.distance),
            },
            money_per_distance: {
              value: Math.round(worker.sum_distance),
            },
            minimum_wage: {
              value: worker.sum_min,
            },
            allowance: {
              value: worker.sum_surcharge,
            },
            late_checkout_surcharge: {
              value: worker.sum_departure,
            },
            short_shift_allowance: {
              value: worker.sum_short_shift,
            },
            prize: {
              value: worker.sum_bonus,
              items: worker.bonuses,
            },
            fine: {
              value: worker.sum_penalty,
              items: worker.fines,
            },
            total_accrued: {
              value: Math.round(worker.sum),
            },
            to_payoff: {
              value: Math.round(worker.sum_round),
            },
            isShowRow: true,
            isActive: b !== -1,
            isVisible: true,
          };
        });*/
      } else {
        const c = this.tableRecords.findIndex((group) => group.code === this.groupCode);
        let activeWorkersCurrentPost = [];
        if (c !== -1) {
          activeWorkersCurrentPost = this.tableRecords[c].records;
        }
        this.workersLocal = value.map((worker) => {
          const b = this.selected.findIndex((workerActive) => workerActive === worker.key);
          
          return {
            is_filial: worker.is_filial ? worker.is_filial : false,
            id: worker.worker_id,
            name: worker.showname,
            key: worker.key,
            isActive: b !== -1,
            isVisible: true,
          };
        });
      }

      this.workersLocal.sort((a, b) => a.name.localeCompare(b.name));

      this.workersStatesLocal = JSON.parse(JSON.stringify(this.workersLocal));
    },
    search(value) {
      if (value.length > 0) {
        this.workersLocal.forEach((post) => {
          if (post.name.toLowerCase().includes(value.toLowerCase())) {
            post.isVisible = true;
          } else {
            post.isVisible = false;
          }
        });
      } else {
        this.workersLocal.forEach((post) => {
          post.isVisible = true;
        });
      }
      setTimeout(() => {
        this.setShadowsOnScroll();
      }, 100);
    },
  },

  methods: {
    displayWorkerSwitcher(worker) {
      return (
        (worker.isVisible && this.isDeliveryTab) ||
        (worker.isVisible && ((!this.isShowWorkersAllFilials && worker.is_filial) || this.isShowWorkersAllFilials))
      );
    },
    setShadowsOnScroll() {
      const shadowBottomElement = document.getElementById("m-add-workers-content-shadow-bottom");
      const shadowTopElement = document.getElementById("m-add-workers-content-shadow-top");
      const scrollElement = document.getElementById("m-add-workers-content");
      if (scrollElement !== null) {
        // if container scrollable
        if (scrollElement.scrollHeight > scrollElement.clientHeight) {
          // top shadow handler
          if (scrollElement.scrollTop !== 0) {
            shadowTopElement.classList.add("m-add-workers-content-shadow-top-active");
          } else if (scrollElement.scrollTop === 0) {
            shadowTopElement.classList.remove("m-add-workers-content-shadow-top-active");
          }
          // bottom shadow handler
          if (scrollElement.scrollTop + scrollElement.clientHeight !== scrollElement.scrollHeight) {
            shadowBottomElement.classList.add("m-add-workers-content-shadow-bottom-active");
          } else {
            shadowBottomElement.classList.remove("m-add-workers-content-shadow-bottom-active");
          }
        } else {
          shadowTopElement.classList.remove("m-add-workers-content-shadow-top-active");
          shadowBottomElement.classList.remove("m-add-workers-content-shadow-bottom-active");
        }
      }
    },
    reset() {
      setTimeout(() => {
        this.search = "";
        this.workersLocal = JSON.parse(JSON.stringify(this.workersStatesLocal));
      }, 150);
      this.localActive = false;
    },
    submitWorkers() {
        this.workersLocal.map( (worker) => {
           let index = this.selected.findIndex((workerActive) => workerActive === worker.key);
           if (worker.isActive && index==-1)  this.selected.push(worker.key);
           else if (!worker.isActive && index>=0) this.selected.splice(index, 1);
        })

      this.$emit("submitWorkers", {
        workers: this.workersLocal,
        codeGroup: this.groupCode,
        selected: this.selected,
      });
      this.localActive = false;
    },
    getAmountWorkerTime(intervals) {
      let sumHoursWorked = 0;
      intervals.forEach((interval) => {
        const start = moment(interval.start);
        const end = moment(interval.finish);
        const duration = moment.duration(end.diff(start)).asHours();
        sumHoursWorked += duration;
      });
      this.sumHoursWorked = sumHoursWorked;
      const n = new Date(0, 0);
      n.setSeconds(+sumHoursWorked * 60 * 60);
      return n.toTimeString().slice(0, 5);
    },
    convertHoursToHHMM(decimalTimeString) {
      let decimalTime = parseFloat(decimalTimeString);
      decimalTime = decimalTime * 60 * 60;
      let hours = Math.floor(decimalTime / (60 * 60));
      decimalTime -= hours * 60 * 60;
      let minutes = Math.floor(decimalTime / 60);
      if (hours < 10) {
        hours = `0${hours}`;
      }
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      return `${hours}:${minutes}`;
    },
    getRevenueStandardHour() {
      if (this.tab === "byDate") {
        const c = this.data.calc.production.posts.findIndex((post) => post.post_code === this.groupCode);
        if (c !== -1) {
          return this.data.calc.production.posts[c].s_norm;
        }
        return 0;
      }

      if (this.tab === "byPeriod") {
        const c = this.data.period.production.posts.findIndex((post) => post.post_code === this.groupCode);
        if (c !== -1) {
          return this.data.period.production.posts[c].s_norm;
        }
        return 0;
      }

      return 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-add-workers {
  &-close {
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 12px;
  }

  &-search {
    margin-top: 26px;
    display: flex;
    align-items: center;

    @media screen and (max-width: 700px) {
      align-items: flex-start;
      flex-direction: column;
    }

    &-switcher {
      max-width: 135px;
      margin-right: 30px;
    }

    &-input {
      width: 70%;

      @media screen and (max-width: 700px) {
        margin-top: 25px;
        width: 100%;
      }
    }
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
  }

  &-content {
    margin-top: 27px;
    overflow-y: auto;
    max-height: 397px;

    @media screen and (max-width: 700px) {
      max-height: calc(100vh - 250px);
    }

    &::-webkit-scrollbar {
      width: 4px !important;
      height: 4px !important;
      background: white;
      cursor: pointer;
      z-index: 300;
      position: relative;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 10px;
      background-clip: padding-box;
      border: none !important;
    }

    &::-webkit-scrollbar-track {
      background: #dfe4ef;
      width: 4px !important;
      border-radius: 10px;
      z-index: 300;
      position: relative;
    }

    &-shadow-top {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      background: transparent;
      opacity: 0;
      pointer-events: none;
      height: 30px;
      width: 100%;

      &-active {
        background: -webkit-gradient(
          linear,
          left bottom,
          left top,
          color-stop(16.13%, rgba(255, 255, 255, 0)),
          color-stop(100%, #ffffff)
        );
        opacity: 1;
      }
    }

    &-shadow-bottom {
      position: absolute;
      background: transparent;
      bottom: 0;
      left: 0;
      pointer-events: none;
      height: 30px;
      width: 100%;
      opacity: 0;
      transition: 0.2s;

      &-active {
        opacity: 1;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.13%, #ffffff 100%);
      }
    }

    &-result {
      &-item {
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  &-actions {
    display: flex;
    margin-top: 22px;
    justify-content: flex-end;

    @media screen and (max-width: 700px) {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);
    }

    &-reset {
      background: white;

      @media screen and (max-width: 700px) {
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        min-height: 38px !important;

        @media screen and (max-width: 700px) {
          justify-content: center;
          width: 100%;
          border-radius: 0;
        }
      }
    }

    &-apply {
      margin-left: 12px;

      @media screen and (max-width: 700px) {
        width: 50%;
        margin-left: 0;
      }

      ::v-deep & .c-button__wrapper {
        min-height: 38px !important;

        @media screen and (max-width: 700px) {
          justify-content: center;
          border-radius: 0;
          width: 100%;
        }
      }
    }
  }
}
</style>
